import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { useParams } from 'react-router';

import c from '../utils/constants';

export default function useCreateComment() {
  const params = useParams();
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useMutation({
    mutationFn: async (payload: any) => {
      const api = new Api(args);

      const data = await api.post(
        await withAcl({
          account: {
            url: 'api/v1/comments/',
            payload,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/comments/`,
            payload,
          },
        }),
      );

      return data;
    },
    onSuccess: async (successData) => {
      const { data } = successData;

      const comments = await queryClient.getQueryData([
        c.NOTES,
        data.parentId,
        c.NOTE_COMMENT,
      ]);

      if (comments) {
        queryClient.invalidateQueries({
          queryKey: [c.NOTES, data.parentId, c.NOTE_COMMENT],
          exact: true,
        });
      }

      queryClient.setQueryData([c.NOTES, data.referenceId], (oldData: any) => {
        const newNotes = [...oldData];

        const noteIndex = newNotes.findIndex(
          (note) => note._id === data.parentId,
        );

        newNotes[noteIndex].comments.total += 1;

        return newNotes;
      });

      queryClient.invalidateQueries({
        queryKey: [c.LOGS, params.id],
      });

      toastSuccess('Successfully created comment');
    },
  });
}
